export default {
  namespaced: true,
  actions: {
    async fetch({ dispatch }) {
      const yearLevels = await this._vm.$axios.get(
        'api/custom-classes/year-levels'
      )
      dispatch(
        'entities/yearLevels/insertOrUpdate',
        { data: yearLevels },
        { root: true }
      )
      return yearLevels
    }
  }
}
